import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import Home from "./pages/Home";
import PropertyDetails from "./pages/PropertyDetails";
import Booking from "./pages/Booking";
import GuestPortal from "./pages/GuestPortal";
import LeaveReview from "./pages/LeaveReview";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/admin/Dashboard";
import AdminReviews from "./pages/admin/Reviews";
import AdminCleaning from "./pages/admin/Cleaning";
import AdminSettings from "./pages/admin/Settings";
import AdminBookings from "./pages/admin/Bookings";
import AdminProperties from "./pages/admin/Properties";
import AdminDiscountCodes from "./pages/admin/DiscountCodes";
import AdminContent from "./pages/admin/Content";
import ProtectedRoute from "./components/ProtectedRoute";
import { ContentProvider } from "./hooks/useContent";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <ContentProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/property/:id" element={<PropertyDetails />} />
            <Route path="/booking" element={<Booking />} />
            <Route path="/guest-portal/:bookingId" element={<GuestPortal />} />
            <Route path="/review/:bookingId" element={<LeaveReview />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
            <Route path="/admin/properties" element={<ProtectedRoute><AdminProperties /></ProtectedRoute>} />
            <Route path="/admin/reviews" element={<ProtectedRoute><AdminReviews /></ProtectedRoute>} />
            <Route path="/admin/cleaning" element={<ProtectedRoute><AdminCleaning /></ProtectedRoute>} />
            <Route path="/admin/discount-codes" element={<ProtectedRoute><AdminDiscountCodes /></ProtectedRoute>} />
            <Route path="/admin/settings" element={<ProtectedRoute><AdminSettings /></ProtectedRoute>} />
            <Route path="/admin/bookings" element={<ProtectedRoute><AdminBookings /></ProtectedRoute>} />
            <Route path="/admin/content" element={<ProtectedRoute><AdminContent /></ProtectedRoute>} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" />
      </div>
    </ContentProvider>
  );
}

export default App;
